import { __rest, __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import React, { useContext } from 'react';
import { FCTheme } from '../../../theming/FCTheme.js';
import Label from '../Label/label.js';
import '../Label/index.js';
import { FormFieldWrapper, RequiredMark, InputWrapper, HintText, ValidationMessage } from './style.js';

var FormField = function FormField(_a) {
  var label = _a.label,
      hint = _a.hint,
      _b = _a.required,
      required = _b === void 0 ? false : _b,
      validationMessage = _a.validationMessage,
      htmlFor = _a.htmlFor,
      children = _a.children,
      rest = __rest(_a, ["label", "hint", "required", "validationMessage", "htmlFor", "children"]);

  var theme = useContext(FCTheme);
  return /*#__PURE__*/React.createElement(FormFieldWrapper, __assign({}, rest), label && /*#__PURE__*/React.createElement(Label, {
    htmlFor: htmlFor
  }, required && /*#__PURE__*/React.createElement(RequiredMark, null, "* "), label), /*#__PURE__*/React.createElement(InputWrapper, null, children), hint && /*#__PURE__*/React.createElement(HintText, {
    id: htmlFor + "_hint",
    theme: theme.theme
  }, hint), validationMessage && /*#__PURE__*/React.createElement(ValidationMessage, {
    theme: theme.theme,
    role: "alert",
    id: htmlFor + "_validation_message"
  }, validationMessage));
};

FormField.displayName = 'FormField';
export default FormField;
export { FormField };